import { render, staticRenderFns } from "./ReceiptForm.vue?vue&type=template&id=2568997d&scoped=true"
import script from "./ReceiptForm.vue?vue&type=script&lang=js"
export * from "./ReceiptForm.vue?vue&type=script&lang=js"
import style0 from "./ReceiptForm.vue?vue&type=style&index=0&id=2568997d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2568997d",
  null
  
)

export default component.exports